import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Id } from 'Src/types/aliases'
import {
	CreateTransportPatentModel,
	TransportPatentModel,
	CreatePatent,
	UpdatePatent,
	DeletePatent,
} from 'Pages/registratorCabinet'

export type TransportPatentsState = {
	transportPatents: TransportPatentModel[]
}

export const transportPatentsInitialState: TransportPatentsState = {
	transportPatents: [],
}

export namespace TransportPatentsNS {
	export type getTransportPatents = PayloadAction<Id>
	export type createTransportPatent = PayloadAction<CreatePatent<CreateTransportPatentModel>>
	export type setTransportPatents = PayloadAction<TransportPatentModel[]>
	export type updateTransportPatent = PayloadAction<UpdatePatent<CreateTransportPatentModel>>
	export type clearTransportPatents = PayloadAction
	export type deleteTransportPatent = PayloadAction<DeletePatent>
}

export const transportPatentsSlice = createSlice({
	name: 'transportPatents',
	initialState: transportPatentsInitialState,
	reducers: {
		getTransportPatents: (state, action: TransportPatentsNS.getTransportPatents) => {},
		createTransportPatent: (state, action: TransportPatentsNS.createTransportPatent) => {},
		setTransportPatents: (state, action: TransportPatentsNS.setTransportPatents) => {
			state.transportPatents = action.payload
		},
		updateTransportPatent: (state, action: TransportPatentsNS.updateTransportPatent) => {},
		clearTransportPatents: (state, action: TransportPatentsNS.clearTransportPatents) => {
			state.transportPatents = []
		},
		deleteTransportPatent: (state, action: TransportPatentsNS.deleteTransportPatent) => {},
	},
})
